__turbopack_context__.v({
  "usermessageblockviewercontainer--animated": "BlockViewerContainer-module-sass-module__GtGEpa__usermessageblockviewercontainer--animated",
  "usermessageblockviewercontainer__animation--in": "BlockViewerContainer-module-sass-module__GtGEpa__usermessageblockviewercontainer__animation--in",
});
